const toMMddyyyy = () => {
  const now = new Date().toISOString().substring(0, 10).split('-')
  return `${now[1]}${now[2]}${now[0]}`
}
export default toMMddyyyy